
<style>

</style>
<template>
    <div v-if="otpData && showTrackingOtpModal && phonenumber">
        <div class="modal fade" id="otpModal" tabindex="-1" aria-labelledby="otpModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered">
              <div class="modal-content p-4 rounded-4">
                <div class="modal-body">
                    <img src="@/assets/Images/Logo/kims-logo.png" alt="KIMSHEALTH" class="mb-3" style="max-width:260px;">
                    <p class="otp_text mb-4">Please enter the OTP received on your registered mobile number</p>
        
                    <div class="d-flex justify-content-center mb-3 gap-1 otp-input-group flex-wrap justify-content-between">
                    <input
                        v-for="(digit, index) in otp"
                        :key="index"
                        type="text"
                        inputmode="numeric"
                        pattern="[0-9]*"
                        class="form-control otp-box text-center"
                        maxlength="1"
                        v-model="otp[index]"
                        @input="focusNext(index, $event)"
                        @keydown.backspace="focusPrev(index, $event)"
                        ref="otpInputs"
                    />
                    </div>
        
                    <small v-if="errors.otpError" class="text-danger">{{ errors.otpError }}</small>
        
                    <button class="btn btn-danger w-100" @click="validationMain" :disabled="trackloading">
                      <span v-if="!trackloading && !resendloading">Confirm</span>
                      <span v-else-if="resendloading">
                        <i class="fa fa-spinner fa-spin"></i> Resending...
                      </span>
                      <span v-else>
                        <i class="fa fa-spinner fa-spin"></i> Processing...
                      </span>
                    </button>
        
                    <div class="d-flex justify-content-between mt-3">
                    <span class="resend">Resend OTP in <span class="timer">{{ formattedTime }}</span></span>
                        <button class="resend_btn text-decoration-none" @click="handleResend" :disabled="timer > 0 || resendloading">
                          <span v-if="!resendloading">Resend</span>
                          <span v-else>
                              <i class="fa fa-spinner fa-spin"></i> Resending...
                          </span>
                        </button>
                    </div>
                </div>
              </div>
          </div>
        </div>
    </div>
    <div id="preloader" v-if="entirePageLoading" style="position: fixed; top:0; left:0; width:100%; height:100%; background: rgba(255,255,255,0.8); z-index: 9999; display:flex; flex-direction:column; justify-content:center; align-items:center;">
      <img src="@/assets/Images/Logo/preloader.png" alt="Loading Image" style="width:100px;">
      <p>Loading...</p>
    </div>
  </template>
  
<script>
  //import { ref, onUpdated, onMounted } from 'vue';
  import { VerifyOtp } from '@/api/Post/track.js';
  import { SendOtp } from '@/api/Post/track.js';
  import { useUserStore } from '@/store/user';
  import { useAgentStore } from '@/store/agent';
  import * as bootstrap from 'bootstrap';
  export default {
    name: "VerifyOTPModel",
    props: {
      otpData: {
        type: Object,
        required: true
      },
      phonenumber: {
        type: String,
        required: true
      },
      showTrackingOtpModal: {  
        type: Boolean,
        required: true,
      },
    },
    computed: {
      formattedTime() {
        const minutes = Math.floor(this.timer / 60);
        const seconds = this.timer % 60;
        return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
      },
    },
    data() {
      let expireInMinutes = parseInt(this.otpData.expire_in); 
      let expireInSeconds = expireInMinutes * 60; 
      if (isNaN(expireInSeconds)) {
          console.error("Invalid expire_in value:", this.otpData.expire_in);
          expireInSeconds = 180; 
      }
      return {
        errors: {},
        trackloading: false,
        resendloading: false,
        otp: ['', '', '', '', ''],
        phoneNumber: null,
        timer: expireInSeconds, 
        timerActive: false,
        countdownInterval: null,
        modal: null, 
        resendCount: 0,
        resendDisabled: false,
        entirePageLoading: false,
      };
      
    },

    mounted() {
      if (this.showTrackingOtpModal) {
        this.initializeModal();
      }

      if (this.timer > 0) {
        this.startTimer();
      }
    },
    watch: {
      showTrackingOtpModal(newValue) {
        if (newValue) {
          this.initializeModal();
        }
      },
    },
    methods: {
      initializeModal() {
        const modalEl = document.getElementById('otpModal');
        if (modalEl) {
          this.modal = new bootstrap.Modal(modalEl);
          this.modal.show(); 
        }
      },
      focusNext(index, event) {
        if (event.target.value && index < 4) {
          this.$refs.otpInputs[index + 1].focus();
        }
      },
      focusPrev(index, event) {
        if (!this.otp[index] && index > 0) {
          this.$refs.otpInputs[index - 1].focus();
        }
      },

      async validationMain() {
        const enteredOtp = this.otp.join('');
        this.errors.otpError = '';
        if (enteredOtp.length !== 5 || this.otp.some(digit => digit === '')) {
          this.errors.otpError = "Please enter a valid 5-digit OTP.";
          return;
        }

        ///console.log('iam here :', this.phonenumber, enteredOtp);

        //this.ApiCall(this.phonenumber, enteredOtp);

        this.trackloading = true;
        ///this.entirePageLoading = true;

        try {
          ///const start = Date.now();
          const response = await VerifyOtp(this.phonenumber, enteredOtp);
          ///console.log('response here :', response);
          //const duration = Date.now() - start;
          ///console.log(` VerifyOtp took ${duration} ms`);

          if (!response.data.success) {
            this.errors.otpError = response.data.message || 'Invalid or expired OTP.';
            return;
          }

          const agentStore = useAgentStore()
          agentStore.setAgent(response.data.agent_id)  
          ///console.log('AgentTrackId:', agentStore.agentTrackId)

          const { token, user_id } = response.data;
          const userStore = useUserStore();

          if (token) {
            localStorage.setItem('authToken', token);
            userStore.setToken(token);
          }

          userStore.setPhone(this.phonenumber);
          userStore.setUser({ user_id });

          localStorage.setItem('userId', JSON.stringify({ user_id }));
          localStorage.setItem('phoneSession', this.phonenumber);

          //$('#otpModal').modal('hide');
          const otpModalEl = document.getElementById('otpModal');
          const otpModal = bootstrap.Modal.getInstance(otpModalEl);

          if (otpModal) {
              otpModal.hide();
          }

          this.$router.push({ name: 'trackDetailsView' });

        } catch (error) {
          //console.error("Axios Error:", error);

          if (error.response?.data) {
            this.errors.otpError = error.response.data.message || "Something went wrong.";
          } else if (error.message) {
            this.errors.otpError = `Request error: ${error.message}`;
          } else {
            this.errors.otpError = "An unknown error occurred.";
          }

        } finally {
          this.trackloading = false;
          ///this.entirePageLoading = false;
        }
      },
    
    


      // startTimer() {
      //   this.stopTimer();

      //   this.countdownInterval = setInterval(() => {
      //     if (this.timer > 0) {
      //       this.timer--;
      //       this.formattedTime = this.formatTime(this.timer);
      //     } else {
      //       this.stopTimer();
      //     }
      //   }, 1000);
      // },
      startTimer() {
        this.stopTimer();

        this.countdownInterval = setInterval(() => {
          if (this.timer > 0) {
            this.timer--; // ONLY update timer
          } else {
            this.stopTimer();
          }
        }, 1000);
      },
      // stopTimer() {
      //   clearInterval(this.countdownInterval);
      //   this.countdownInterval = null;
      //   this.timerActive = false;
      //   this.formattedTime = '';
      // },
      stopTimer() {
        if (this.countdownInterval) {
          clearInterval(this.countdownInterval);
          this.countdownInterval = null;
        }
      },
      // formatTime(seconds) {
      //   const m = Math.floor(seconds / 60).toString().padStart(2, '0');
      //   const s = (seconds % 60).toString().padStart(2, '0');
      //   return `${m}:${s}`;
      // },
      
      async handleResend() {
        if (this.resendDisabled || this.resendCount >= 1) {
          this.errors.otpError = 'You’ve exceeded the OTP resend limit.';
          return;
        }

        this.resendloading = true;
        this.errors.otpError = '';
        try {
          const sendOTP = await SendOtp(this.phonenumber);

          // if (sendOTP.data.success === true) {
          //   this.resendCount++;
          //   this.timer = 180; 
          //   this.timerActive = true;
          //   this.formattedTime = this.formatTime(this.timer);
          //   this.startTimer();

          //   if (this.resendCount >= 1) {
          //     this.resendDisabled = true;
          //     setTimeout(() => {
          //       this.resendCount = 0;
          //       this.resendDisabled = false;
          //     }, 5 * 60 * 1000);
              
          //   }

          //   this.errors.otpError = '';
          // } else {
          //   this.errors.otpError = sendOTP.data.message || 'Error sending OTP.';
          //   this.resendloading = false;
          //   this.trackloading = false;
          // }
          if (sendOTP.data.success) {
            this.resendCount++;

            this.timer = 180; // reset timer
            this.startTimer(); // restart timer

            if (this.resendCount >= 1) {
              this.resendDisabled = true;

              setTimeout(() => {
                this.resendCount = 0;
                this.resendDisabled = false;
              }, 5 * 60 * 1000);
            }

          } else {
            this.errors.otpError = sendOTP.data.message || 'Error sending OTP.';
          }
          
        } catch (error) {
          this.errors.otpError = error?.message || 'Something went wrong.';
          this.resendloading = false;
          this.trackloading = false;
        } finally {
          this.resendloading = false;
          this.trackloading = false;
        }
      },

    },
    beforeUnmount() {
      this.stopTimer();
    }
  };


</script>
